module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ch-t"
  }, [_vm._v("THE LAYERED APPROACH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is nothing I like better than circular shapes—they are so satisfying. All the quilts in this book are made using one basic technique with many variations. Once you learn the basic technique, the possibilities are endless.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-1"
    }
  }, [_vm._v("Using Multiple Layers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I came up with this design idea, I realized that it was the use of multiple layers that made it so interesting, because the viewer is not quite sure which layer is really the dominant one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The basic concept behind the technique is simple: Start with a square. Place a cornerstone (KISS) on each corner, and voilà, you have a circle. In other words, "), _c('i', [_vm._v("layering")]), _vm._v(" the cornerstone KISSes on a square creates a circle.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place those blocks next to each other and you can see how it begins. The cornerstone KISSes can be in four individual pieces, or they can be combined into one piece that covers four block corners.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Circle Takes the Square")]), _vm._v(" is probably the simplest way to use this technique: KISSes are placed on the block corners, creating the circles.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('i', [_vm._v("Circle Takes the Square")]), _vm._v(" by Judith Sabourin (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now look at a detail of the center of "), _c('i', [_vm._v("Color Play 2.")]), _vm._v(" The same technique is used, but because the KISSes are strategically placed black-and-white prints, two things happen: the square disappears and the white shapes come forward while the black shapes recede.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('i', [_vm._v("Color Play 2")]), _vm._v(" by Louisa L. Smith (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-2"
    }
  }, [_vm._v("Taking a Cue from M. C. Escher")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some of my favorite quilts take a cue from M. C. Escher in their use of positive and negative shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The First Layer of "), _c('i', [_vm._v("Circular Anomaly")]), _vm._v(" (see project instructions) is made up of grayscale squares. But rather than layering just KISSes on top, the design changes midway through to layered HUGs, switching the positive to negative—classic M. C. Escher.")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/tip.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tipp"
  }, [_vm._v("More Escher-effect quilts are "), _c('i', [_vm._v("Jekyll and Hyde")]), _vm._v(", "), _c('i', [_vm._v("Dualisti")]), _vm._v("c, and "), _c('i', [_vm._v("Synchronicity")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("First Layer of "), _c('i', [_vm._v("Circular Anomaly")])]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg9b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('i', [_vm._v("Circular Anomaly")]), _vm._v(" by Louisa L. Smith (project instructions)")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-3"
    }
  }, [_vm._v("Going in Reverse")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Another interesting design approach is to add circles or ovals (HUGs) instead of KISSes to create the negative spaces. In "), _c('i', [_vm._v("Color, Couleur, Kleur")]), _vm._v(" (full quilt), the First Layer is made from squares of silk tie fabric. The oval HUGs are made from solid fabrics that are pieced and aligned with the seams of the squares.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-4"
    }
  }, [_vm._v("Seeing the Layers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To see examples of the First Layers and finished quilts, take a look at the following:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  "), _c('i', [_vm._v("Double Vision Kimono Style")]), _vm._v(" by Louisa L. Smith")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  "), _c('i', [_vm._v("Floaters")]), _vm._v(" by Louisa L. Smith")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  "), _c('i', [_vm._v("Somewhere in Space")]), _vm._v(" by Allison Lockwood")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  "), _c('i', [_vm._v("Double Trouble")]), _vm._v(" by Jean Impey")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("•  "), _c('i', [_vm._v("Ova Nova")]), _vm._v(" by Louisa L. Smith")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "c-5"
    }
  }, [_vm._v("Even More Possibilities")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As you get into the technique, you will see that all sorts of combinations are possible. Take a look at The Gallery and The Projects, and in no time you’ll be thinking about your own combinations.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Detail of "), _c('i', [_vm._v("Color, Couleur, Kleur")]), _vm._v(" (full quilt)")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg10a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Using both sides of Talbott tie silks")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6036e0db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 75
// module chunks = 0